export default __webpack_public_path__ + "static/media/doctor2.5a898213.jpg";